let maxAttempts = 50;
let attempts = 0;

const interval = setInterval(function () {
    const sliderTextElement = document.querySelector(
        'h3[data-pf-type="Heading2"].pf-9dde980a2674-34_'
    );
    const sliderTextElementTwo = document.querySelector(
        'h3[data-pf-type="Heading2"].pf-e6b45630ea32-8_'
    );

    if (sliderTextElement || sliderTextElementTwo) {
        const currentUrl = window.location.href;

        let currencySymbol = "€"; // Default to Euro
        if (currentUrl.includes("/en-uk") || currentUrl.includes("/nl-uk") || currentUrl.includes("/de-uk") || currentUrl.includes("/fr-uk")) {
            currencySymbol = "£"; // GBP for UK
        }

        if (sliderTextElement) {
            const updatedContentOne = sliderTextElement.innerHTML.replace(/€|&euro;/g, currencySymbol);
            sliderTextElement.innerHTML = updatedContentOne;
        }

        if (sliderTextElementTwo) {
            const updatedContentTwo = sliderTextElementTwo.innerHTML.replace(/€|&euro;/g, currencySymbol);
            sliderTextElementTwo.innerHTML = updatedContentTwo;
        }

        clearInterval(interval); // Stop checking once found
    } else {
        console.log("Target elements not found yet. Retrying...");
    }

    attempts++;
    if (attempts >= maxAttempts) {
        clearInterval(interval);
        console.warn("Stopped checking after max attempts. Elements not found.");
    }
}, 100);


document.addEventListener("DOMContentLoaded", function () {
        const shippingTextElement = document.querySelector('.currency-update');

    if (shippingTextElement) {

        const currentUrl = window.location.href;

        let currencySymbol = "€"; // Default to Euro
        if (currentUrl.includes("/en-uk") || currentUrl.includes("/nl-uk") || currentUrl.includes("/de-uk") || currentUrl.includes("/fr-uk")) {
            currencySymbol = "£";
        }
      
        const updatedContent = shippingTextElement.innerHTML.replace(/€|&euro;/g, currencySymbol);

        shippingTextElement.innerHTML = updatedContent;
    } else {
        console.warn("Target element not found.");
    }
});
